// Mirrors the backend's CertificateReportMatchMode enum (CVPortal.Logic.Models.Reports).
// Sent/received as the raw numeric value — no global StringEnumConverter is registered
// (Startup.cs's AddNewtonsoftJson), so enums serialize as integers by default.
export const CertificateReportMatchMode = {
  Any: 1,
  All: 2,
} as const;

export type CertificateReportMatchModeValue =
  (typeof CertificateReportMatchMode)[keyof typeof CertificateReportMatchMode];

export interface CertificateReportSearchRequest {
  certificateIds: number[];
  matchMode: CertificateReportMatchModeValue;
  /** yyyy-MM-dd, or null/undefined for "no constraint on this side" */
  obtainedFrom?: string | null;
  obtainedTo?: string | null;
  page: number;
  pageSize: number;
}

/** Same filter shape as the search request, minus paging — backs "Export CV for all matching." */
export interface CertificateReportAllIdsRequest {
  certificateIds: number[];
  matchMode: CertificateReportMatchModeValue;
  obtainedFrom?: string | null;
  obtainedTo?: string | null;
}

export interface MatchedCertificateInfo {
  certificateId: number;
  certificateName: string;
  obtainedDate: string;
}

export interface CertificateReportPersonRow {
  personId: number;
  firstName: string;
  lastName: string;
  email: string;
  officeLocation: string | null;
  thumbnailBase64: string | null;
  matchedCertificates: MatchedCertificateInfo[];
}

export interface CertificateReportPagedResult {
  items: CertificateReportPersonRow[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}
